// src/components/MainPage.js
import React, { useEffect, useRef } from 'react';
import styles from './News.module.css';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

function Page2() {    
    const { news } = useSelector(state => state.newsFeeder);
    const { idx } = useParams();
    const newsId = idx ?? 0; // Set to 0 if idx is undefined

    // Create a ref for each news item
    const refs = useRef([]);  

    useEffect(() => {        
        // Scroll to the item with the id that matches newsId
        if (newsId && refs.current[newsId]) {
            const element = refs.current[newsId];
            const container = document.querySelector('.main-content'); // Select your scrollable container
            const elementTop = element.getBoundingClientRect().top - container.getBoundingClientRect().top;
            const offset = container.clientHeight / 2 - element.clientHeight / 2;
    
            container.scrollTo({
                top: elementTop - offset, // Center the element vertically within the container
                behavior: 'smooth'
            });          
        }
    }, [newsId]);



    const truncateText = (text, wordLimit) => {
        const words = text.split(' ');
        if (words.length > wordLimit) {
          return words.slice(0, wordLimit).join(' ') + '...';
        }
        return text;
      };

    return (
        <div className={styles.main_page}>
            <header className={styles.main_header}>
                <h1>Crypto News</h1>
            </header>
            <main>
                <section className={styles.content}>
                    <div>
                        {news.map((item, index) => (
                            <div key={index} ref={el => refs.current[item.id] = el}>
                                <div style={{ height:'400px', border: '1px solid gray', borderRadius:'10px', textAlign: 'left', backgroundColor: item.id === newsId ? '#2a1c5e' : '#000032'}}>
                                    <table style={{ width: '100%', height:'100%', borderCollapse: 'collapse' }}>
                                        <tbody>
                                            <tr style={{height:'20%'}}>
                                                <td colSpan="2" style={{ padding: '10px', textAlign: 'center' }}>
                                                    <h2>{item.title}</h2>
                                                </td>
                                            </tr>
                                            <tr style={{height:'80%'}}>
                                                <td style={{ padding: '10px', textAlign: 'center' }}>
                                                    <img src={item.source_info.img} alt="img" style={{width:'100px'}} />
                                                </td>
                                                <td style={{ padding: '10px', textAlign: 'justify', fontSize:'13pt' }}>
                                                    {truncateText(item.body===''?item.title:item.body, 100)}
                                                </td>
                                            </tr>
                                            <tr style={{height:'20px'}}>
                                                <td className={styles.table_row} colSpan="2" style={{ padding: '10px', textAlign: 'center' }}>                                                
                                                    <a className='link_news' href={item.url} target="_blank" rel="noopener noreferrer">
                                                        Find out more about this article at 
                                                        <span className="title" style={{color:'gold', fontSize:'15pt'}}> {item.source_info.name}</span>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>                                    
                                </div>
                                <br/><br/>
                            </div>
                        ))}
                    </div>                    
                </section>
            </main>            
        </div>
    );
}

export default Page2;